import type {ReactElement} from 'react';
import {FontSizeControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-size-control/font-size-control';
import {HEADING_SIZES} from '@FormMakerReact/layout/form-maker-right-panel/sectors/heading-sector/heading-sector.types';
import type {HeadingSizeControlProps} from './heading-size-control.types';

export function HeadingSizeControl({component}: HeadingSizeControlProps): ReactElement {
  return <FontSizeControl component={component} sizes={HEADING_SIZES} />;
}
